import {
  GET_DOCUMENT_FORM_DATA,
  GET_DOCUMENT_DETAIL_DATA,
  SET_DOCUMENT_FORM_DATA,
  SET_DOCUMENT_DETAIL_DATA,
  SET_FILTER_FORM_CONFIG,
  GET_DOCUMENTS_LINK_ACTION,
  SET_DOCUMENT_CATEGORIES_DATA,
  GET_DOCUMENT_CATEGORIES_DATA,
  GET_DOCUMENT_NOTIFY_DATA,
  SET_DOCUMENT_NOTIFY_DATA,
  GET_DOCUMENT_GUIDELINE_DATA,
  SET_DOCUMENT_GUIDELINE_DATA,
  SET_FILTER_NOTIFY_CONFIG,
  SET_FILTER_GUIDELINE_CONFIG,
} from './constants';

const getDocumentFormDataAction = (payload) => ({
  type: GET_DOCUMENT_FORM_DATA,
  payload,
});

const setDocumentFormDataAction = (payload) => ({
  type: SET_DOCUMENT_FORM_DATA,
  payload,
});
const getDocumentNotifyDataAction = (payload) => ({
  type: GET_DOCUMENT_NOTIFY_DATA,
  payload,
});

const setDocumentNotifyDataAction = (payload) => ({
  type: SET_DOCUMENT_NOTIFY_DATA,
  payload,
});
const getDocumentGuidelineDataAction = (payload) => ({
  type: GET_DOCUMENT_GUIDELINE_DATA,
  payload,
});

const setDocumentGuidelineDataAction = (payload) => ({
  type: SET_DOCUMENT_GUIDELINE_DATA,
  payload,
});

const setFilterFormConfig = (payload) => ({
  type: SET_FILTER_FORM_CONFIG,
  payload,
});

const setFilterNotifyConfig = (payload) => ({
  type: SET_FILTER_NOTIFY_CONFIG,
  payload,
});

const setFilterGuidelineConfig = (payload) => ({
  type: SET_FILTER_GUIDELINE_CONFIG,
  payload,
});

const getDocumentDetailData = (payload) => ({
  type: GET_DOCUMENT_DETAIL_DATA,
  payload,
});

const setDocumentDetailData = (payload) => ({
  type: SET_DOCUMENT_DETAIL_DATA,
  payload,
});

const getDocumentsLinkAction = (payload) => ({
  type: GET_DOCUMENTS_LINK_ACTION,
  payload,
});

const getDocumentCategoriesDataAction = (payload) => ({
  type: GET_DOCUMENT_CATEGORIES_DATA,
  payload,
});

const setDocumentCategoriesDataAction = (payload) => ({
  type: SET_DOCUMENT_CATEGORIES_DATA,
  payload,
});

export {
  setFilterFormConfig,
  getDocumentFormDataAction,
  setDocumentFormDataAction,
  getDocumentDetailData,
  setDocumentDetailData,
  getDocumentsLinkAction,
  getDocumentCategoriesDataAction,
  setDocumentCategoriesDataAction,
  getDocumentNotifyDataAction,
  setDocumentNotifyDataAction,
  getDocumentGuidelineDataAction,
  setDocumentGuidelineDataAction,
  setFilterNotifyConfig,
  setFilterGuidelineConfig,
};
